import { render, staticRenderFns } from "./checkToken.vue?vue&type=template&id=2fc9fe87&scoped=true&"
import script from "./checkToken.vue?vue&type=script&lang=js&"
export * from "./checkToken.vue?vue&type=script&lang=js&"
import style0 from "./checkToken.vue?vue&type=style&index=0&id=2fc9fe87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc9fe87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc9fe87')) {
      api.createRecord('2fc9fe87', component.options)
    } else {
      api.reload('2fc9fe87', component.options)
    }
    module.hot.accept("./checkToken.vue?vue&type=template&id=2fc9fe87&scoped=true&", function () {
      api.rerender('2fc9fe87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/checkToken.vue"
export default component.exports